import BaseBonusCodeField from 'registration/js/base/fields/bonus_code';

import template from 'registration/templates/dark/fields/bonus_code.html';

const BonusCodeField = BaseBonusCodeField.extend({
    template
});

export default BonusCodeField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/bonus_code.js